import idParser from '@/lib/helpers/id-parser';

const renderScopedSlot = (component, scopedSlotToRender) => {
  const {
    value,
    validationState,
    errorMessages,
    canEditValue,
  } = component;

  const slotDefault = scopedSlotToRender({
    value,
    validationState,
    canEditValue,
    fieldId: component.field.id,
    dataTestId: idParser(component.field.name),
    onChange: async (...args) => {
      await component.field.onChange(...args);
    },
    onInstantChange: (...args) => component.field.onInstantChange(...args),
    errorMessages,
  });

  return slotDefault;
};

const contextForUiGen = (obj) => {
  const context = {
    isInvalid: obj.isInvalid,
    isValid: obj.isValid,
    ...obj.uiProps,
  };

  return context;
};

export default {
  name: 'FieldRender',

  props: {
    field: {
      type: Object,
      required: true,
    },
  },

  computed: {
    name() {
      return this.field.name;
    },

    value() {
      return this.field.value;
    },

    validationState() {
      return this.field.validationState;
    },

    errorMessages() {
      return this.field.errorMessages;
    },

    canEditValue() {
      return this.field.isEditable;
    },
  },

  created() {
    this.field.$rendererComponent = this;
  },

  render(createElement) {
    const scopedSlotToRender = this.$scopedSlots.default;

    const renderedSlotDefault = renderScopedSlot(this, scopedSlotToRender);

    const contextForUi = contextForUiGen(this.field);

    return createElement(
      this.field.component.ui,
      {
        tag: 'component',
        attrs: contextForUi,
      },
      [
        renderedSlotDefault,
      ],
    );
  },
};
